import type { FaireProductEntity } from "../../entity_types/product";

export const p_yqxjmt7jur: FaireProductEntity = {
  token: "p_yqxjmt7jur",
  type: "product",
  name: "Cashmere Shawl (wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl: "https://cdn.faire.com/fastly/1ee66821bdfdb354d458e6ffc6f58f98cfcecc65b01dd34bb96a91cb72b09031.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6a851cbaeebf5e10ae94172772156602a1aa064512c0204180cc61ec0be2a45.jpeg",
    "https://cdn.faire.com/fastly/74cecf10219d39f7f788720116d271195237942e3dc3974fd822009cbbb8c237.jpeg",
    "https://cdn.faire.com/fastly/c2536126d522b1eed5a1cbf73be9ee6c22a493253f4e45804f37aab9e5dbb589.jpeg",
    "https://cdn.faire.com/fastly/a59359a60db92f3b5bd1bfc321d1a467d66833cbfb19f6b7f6246c242e4fb684.jpeg",
    "https://cdn.faire.com/fastly/2dc592f2131f1ca659d7c56b6fda769630c883373f2b2133a8d84e1cb3d58149.jpeg",
    "https://cdn.faire.com/fastly/1b804438d9ef676ca89a093a73838989addd1abb8c7d7958c03e1bfab15efbe1.jpeg",
    "https://cdn.faire.com/fastly/45e53226f140f622420a7fb713af10db176fd5de3d174b423239de33d2139c80.jpeg",
    "https://cdn.faire.com/fastly/1c68d529332bc6626cb80ba3c1dea1eba121afa30ecea00411d88610eac8fbdc.jpeg",
    "https://cdn.faire.com/fastly/cc12322237347a715de149a2704a79d4b80f015b003548af82fd2c00b334fb38.jpeg",
    "https://cdn.faire.com/fastly/c5379078d04a674cf27e670c709b5bd733594fd7371150d121adfea631cd1f6d.jpeg",
    "https://cdn.faire.com/fastly/632bfcf9e0478f1926085723b9abfdc9d87fee6a0fe9ec7954df136fa3fd9b55.jpeg",
    "https://cdn.faire.com/fastly/de2b522996a2a3fafbd62d6051257392a469ba7aef3a632f2dbe7e9b816618cf.jpeg",
    "https://cdn.faire.com/fastly/333ad26d5bc762451681940a9ff44d90ca6f4ea451fa1c21c635135c6f47ae8b.jpeg",
    "https://cdn.faire.com/fastly/f2d562c147b52ea457a8cc4c5c483cdb90faecbe0a9478d78776e311c3ad16be.jpeg",
    "https://cdn.faire.com/fastly/6714cbbd245ee8671dc2c9559a428de66b1f77ef7f96cf87aef62a7366f31abe.jpeg",
    "https://cdn.faire.com/fastly/9a6d315c8be6a785d8e0bfe823794e8fdf332766fcd97711c2ee0c8c49cef629.jpeg",
    "https://cdn.faire.com/fastly/7d1ed66b9d225b225e4805718a905f83f02f18d12f095d52cd12731e792d5c98.jpeg",
    "https://cdn.faire.com/fastly/00bff1bcb794b3121bb464b3290ea1939f943342fdb5307de2d6d8cf8760fd88.jpeg",
    "https://cdn.faire.com/fastly/cd450153e1d5f0243e7fc8102da3a5937ce1953834eb2374d9aff5e796fd635a.jpeg",
    "https://cdn.faire.com/fastly/9b78353531b26456830dffb75043dd3f5dda687bbfe0085ccfc1f6225b575949.jpeg",
    "https://cdn.faire.com/fastly/226d53b70861d4279cdec35939a3eeefe4c4867d4f3cce268090db040e8cf5ac.jpeg",
    "https://cdn.faire.com/fastly/7ac70b332af4c398b5911ea1390b8ccbdfea2516677730249bc37b0189d09474.jpeg",
    "https://cdn.faire.com/fastly/f938131063fc796b2c893677a848f9e46d00dbd7594ed072f7924b44471ddaba.jpeg",
    "https://cdn.faire.com/fastly/0b452eb848a56e5f3644fa01ac5ba31745ea198b36716c21df2fc76789396bb4.jpeg",
    "https://cdn.faire.com/fastly/fde43d3e7de024f686ca49636cb9ab506546f709fb00f16438a5cb9cd313e518.jpeg"
  ],
  priceDollars: 42,
  description: "Why We Made This?\n\nA refined take on a classic staple, the Cashmere Shawl offers a soft, generous silhouette that’s large enough to wrap around the shoulders or tie as a head scarf. Its fluid versatility makes it a staple for everyday, multi-wear and a timeless gift for any occasion.\n\n\n\n\nContents: \n\n35 cashmere 65 wool\n\n\n\n\nSizing:\n\nOne size fits most \n\n\n\n\nApproximate Measurements: \n\nWidth : 64\" / Length: 34\"\n\n\n\nCare Instructions:\n\n\n Dry clean only \n\n\n\nMade in China\n\n\n\n***Order in units of 6 (6,12,18,24 etc)\n\n\n\n\nMSRP: $84 USD\n",
  tags: [],
  msrpDollars: 84,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:48.293Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
